import { useEffect, useState } from "react";

/** Вкладка сейчас на экране (не свёрнута и не в фоне). */
export function isPageVisible(): boolean {
  return (
    typeof document === "undefined" || document.visibilityState !== "hidden"
  );
}

/**
 * Следит, видна ли вкладка. Нужна звуку всплывашек: опрос идёт и в скрытых
 * вкладках, а звенеть должна та, на которую человек смотрит.
 */
export function usePageVisible(): boolean {
  const [visible, setVisible] = useState(isPageVisible);
  useEffect(() => {
    const sync = () => setVisible(isPageVisible());
    document.addEventListener("visibilitychange", sync);
    return () => document.removeEventListener("visibilitychange", sync);
  }, []);
  return visible;
}
